import { ErrorBoundary } from "@circle-react-shared/ErrorBoundary";
import { useEffect } from "react";

import { CommentsContainer } from "@/react/components/CommentsCompass/CommentsContainer";
import { CommentsErrorFallback } from "@/react/components/CommentsCompass/CommentsErrorFallback";
import { useCommentsScroll } from "@/react/components/CommentsCompass/Provider/ScrollContext";
import { useCommentsSection } from "@/react/components/CommentsCompass/Provider/SectionContext";
import { useCommentsDeepLink } from "@/react/components/CommentsCompass/Provider/useCommentsDeepLink";

import { HierarchyView } from "./HierarchyView";
import { ListView } from "./ListView";

export interface FeedProps {
  commentsCount: number;
  scrollableTarget?: HTMLElement | null;
}

export const Feed = ({ commentsCount, scrollableTarget }: FeedProps) => {
  const { deepLinkedCommentId } = useCommentsDeepLink();
  const { registerSectionScrollTarget, scrollToSection } = useCommentsScroll();
  const { isSectionScrollPending, clearSectionScrollRequest } =
    useCommentsSection();

  useEffect(() => {
    if (!isSectionScrollPending) return;
    if (!deepLinkedCommentId) scrollToSection();
    clearSectionScrollRequest();
  }, [
    isSectionScrollPending,
    deepLinkedCommentId,
    scrollToSection,
    clearSectionScrollRequest,
  ]);

  return (
    <ErrorBoundary name="CommentFeed" fallback={CommentsErrorFallback}>
      <CommentsContainer ref={registerSectionScrollTarget}>
        {deepLinkedCommentId ? (
          <HierarchyView
            commentId={deepLinkedCommentId}
            commentsCount={commentsCount}
          />
        ) : (
          <ListView scrollableTarget={scrollableTarget} />
        )}
      </CommentsContainer>
    </ErrorBoundary>
  );
};
